<template>
  <div id="jumbotron">
    <div class="container">
      <h1>English Classes<br>5-11 years old</h1>
    </div>
  </div>

  <div class="container pt-5">
    <div class="row m-0">
      <div class="col-12 col-md-4 col-lg-3">
        <h2 class="text-primary mb-4">Course structure</h2>
      </div>
      <div class="col-12 col-md-8 col-lg-9">
        <p>
          We have 5 different levels for kids learning English from ages 5-11, based not just on the student’s age but also their level of English and their own particular needs.
        </p>

        <p>
          Choosing topics that will appeal to young learners, we build up their confidence and their skills in all areas of the language.
        </p>

        <p>
          Creative Writing Classes – a wonderful English writing course that gives our junior students the chance to express themselves as they take their first steps towards creative thinking.
        </p>

        <div id="classPhotos" class="row m-0">
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_5_to_11/Classes+5+to+11+-+1.webp" alt="English Class for 5 to 11 Years Old" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_5_to_11/Classes+5+to+11+-+2.webp" alt="English Class for 5 to 11 Years Old" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_5_to_11/Classes+5+to+11+-+3.webp" alt="English Class for 5 to 11 Years Old" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_5_to_11/Classes+5+to+11+-+4.webp" alt="English Class for 5 to 11 Years Old" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_5_to_11/Classes+5+to+11+-+5.webp" alt="English Class for 5 to 11 Years Old" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_5_to_11/Classes+5+to+11+-+6.webp" alt="English Class for 5 to 11 Years Old" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_5_to_11/Classes+5+to+11+-+7.webp" alt="English Class for 5 to 11 Years Old" class="w-100 rounded"></div>
          <div class="col-6 col-sm-4 col-lg-3"><img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/photos/class_5_to_11/Classes+5+to+11+-+8.webp" alt="English Class for 5 to 11 Years Old" class="w-100 rounded"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="bg-color py-5 mt-5">
    <div class="container">
      <div class="row m-0">
        <div class="col-12 col-md-4 col-lg-3">
          <h2 class="text-primary mb-4">Fee structure</h2>
        </div>
        <div class="col-12 col-md-8 col-lg-9">
          <ul>
            <li><strong>RM100</strong> proficiency assessment & placement test.</li>
            <li><strong>RM200</strong> registration & administration fee (one off).</li>
            <li><strong>RM790 per term</strong>. 1 term comprises 10 lessons, and these lessons are once a week for 2 hours. There are 4 terms in the year, and if you join part of the way through a term, we will happily pro-rate your fees.</li>
            <li>The cost of the coursebook (to last the year) depends on the student’s level. </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <ContactUs />
</template>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }

h1 { font-size: 3.5em; }
h2 { font-size: 3em; }

.bg-color {
  background-color: #F4F3F9;
}

#classPhotos img {
  max-width: 225px;
  height: auto;
  object-fit: cover; 
  aspect-ratio: 1 / 1;
  margin-bottom: 20px;
}

li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}
</style>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>